import axios from 'axios';
import { isTokenExpired } from '../utils/tokenUtils';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:5000/api';

const PUBLIC_AUTH_PATHS = [
  '/Auth/login',
  '/Auth/register',
  '/Auth/forgot-password',
  '/Auth/reset-password',
];

const isPublicAuthRequest = (url?: string) =>
  !!url && PUBLIC_AUTH_PATHS.some((path) => url.includes(path));

const isPublicAuthPage = () => {
  const path = window.location.pathname;
  return (
    path.includes('/login') ||
    path.includes('/esqueci-senha') ||
    path.includes('/redefinir-senha')
  );
};

export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para adicionar o token JWT
api.interceptors.request.use(
  (config) => {
    // Rotas públicas de autenticação não devem depender de token
    if (isPublicAuthRequest(config.url)) {
      return config;
    }

    const token = localStorage.getItem('auth_token');

    if (token) {
      if (isTokenExpired(token)) {
        localStorage.removeItem('auth_token');
        localStorage.removeItem('user');
        if (!isPublicAuthPage()) {
          window.location.href = '/login';
        }
        return Promise.reject(new Error('Token expirado'));
      }

      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para tratamento de erros
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !isPublicAuthRequest(error.config?.url)) {
      localStorage.removeItem('auth_token');
      localStorage.removeItem('user');

      if (!isPublicAuthPage()) {
        window.location.href = '/login';
      }
    }

    if (import.meta.env.DEV) {
      console.error('API Error:', {
        url: error.config?.url,
        method: error.config?.method,
        status: error.response?.status,
        data: error.response?.data,
      });
    }

    return Promise.reject(error);
  }
);

export default api;
